// Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
// See LICENSE in the project root for license information.

import { LoadThemedStylesLoader } from './LoadThemedStylesLoader';

export = LoadThemedStylesLoader;
